import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import useAsync from "../hooks/useAsync";
import FaqServices from "../services/FaqServices";
import DeleteButton from "./Button/DeleteButton";
import UpdateFaqCategory from "./Update Model/UpdateFaqCategory";
import Modal from "react-modal";
import ReactPaginate from "react-paginate";
import Pagetitle from "./PageTitle";
import * as XLSX from "xlsx";
import { Link } from "react-router-dom";

Modal.setAppElement("#root");

function FaqcategoryList() {
    const { data, error, isLoading, run } = useAsync(FaqServices.getAllFaqCategory);
    //   console.log(data);
    const [currentPage, setCurrentPage] = useState(1);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [statusFilter, setStatusFilter] = useState('');
    const [searchTerm, setSearchTerm] = useState('');


    const [activeIndex, setActiveIndex] = useState(null);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [selectedEdit, setSelectedEdit] = useState(null);




    const facatPerPage = 10;
    const handleViewDetails = (user) => {
        setSelectedUser(user);
        setIsModalOpen(true);
    };

    const handleEditDetails = (help) => {
        setSelectedEdit(help);
        setIsEditModalOpen(true);
        toggleActionMenu(null);
    };

    const handleDelete = (help) => {
        setSelectedEdit(help);
        setIsDeleteModalOpen(true);
        toggleActionMenu(null);
    };

    const closeEditModal = () => {
        setIsEditModalOpen(false);
        setSelectedEdit(null);
    };
    const toggleActionMenu = (index) => {
        setActiveIndex(index === activeIndex ? null : index); // Toggle the active index
    };
    const closeDeleteModal = () => {
        setIsDeleteModalOpen(false);
        setSelectedEdit(null);
    };


    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedUser(null);
    };

    const handlePageClick = (data) => {
        setCurrentPage(data.selected + 1);
    };
    const handleStatusFilterChange = (e) => {
        setStatusFilter(e.target.value);
    };


    const formatDate = (dateString) => {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
            return 'N/A';
        }
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear().toString();
        return `${day}-${month}-${year}`;
    };

    const filteredData = data?.data?.filter((faqcat) =>
        faqcat.titleEnglish.toLowerCase().includes(searchTerm.toLowerCase()) ||
        faqcat.titleHindi.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };


    // Calculate pagination values
    const indexOfLastUser = currentPage * facatPerPage;
    const indexOfFirstUser = indexOfLastUser - facatPerPage;
    const paginatedInventory = filteredData?.slice(indexOfFirstUser, indexOfLastUser);  // Slice the filtered users for pagination


    return (
        <div className="right_col" role="main">
            <Pagetitle />
            <div className="container-box px-0 user-manager" style={{ overflowX: "auto", whiteSpace: "nowrap", marginBottom: "20px" }}>
                <div className="container-box-top-header px-4">
                    <div className="container-box-top-header-left-2">
                        <input
                            type="search"
                            name="search"
                            placeholder="Search"
                            value={searchTerm}
                            onChange={handleSearchChange}
                        />
                        <button className="search-btn">
                            <FontAwesomeIcon icon={faSearch} />
                        </button>
                    </div>

                    <div className="sub-title-box-right d-flex">
                        <Link className="Add-new-btn site-btn-green" to="/add-faq-category">
                            <img src="img/add-plus.svg" alt="" />
                            <span className="ms-2">Add New</span>
                        </Link>

                    </div>
                </div>
                <div className="container-box-inner">
                    <table
                        id="example"
                        className="table table-striped"
                        style={{ width: "100%" }}
                    >
                        <thead>
                            <tr>
                                <th>S. No.</th>
                                <th>Title English</th>
                                <th>Title Hindi</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedInventory?.map((faqcat, index) => (
                                <tr key={faqcat?._id}>
                                    <td>{index + 1 + (currentPage - 1) * facatPerPage}</td>
                                    <td>{faqcat?.titleEnglish}</td>
                                    <td>{faqcat?.titleHindi}</td>
                                    <td >
                                        <div className="action_toggle_outer">
                                            <button className="action_toggle" onClick={() => toggleActionMenu(index)}>
                                                <i className="fa fa-ellipsis-v" />
                                            </button>
                                            {activeIndex === index && (
                                                <div className="action_toggle_content product-edit show d-block">
                                                    <ul className="list-unstyled">
                                                        <li>
                                                            <button className="close_toggle" onClick={() => toggleActionMenu(null)}>
                                                                <i className="fa fa-close" />
                                                            </button>
                                                        </li>
                                                        <li>
                                                            <button className="edit" style={{ backgroundColor: '#F98F42' }}
                                                                onClick={() => handleEditDetails(faqcat)}>Edit</button>
                                                        </li>
                                                        <li>
                                                            <button className="reject" onClick={() => handleDelete(faqcat)}>Delete</button>
                                                        </li>
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>
                {/* Pagination */}
                <div className="pagination">
                    <ReactPaginate
                        pageCount={Math.ceil((filteredData?.length || 0) / facatPerPage)}
                        pageRangeDisplayed={3}
                        marginPagesDisplayed={1}
                        onPageChange={handlePageClick}
                        containerClassName={"pagination"}
                        activeClassName={"active"}
                        previousLabel={"Previous"}
                        nextLabel={"Next"}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        initialPage={currentPage - 1}
                        disableInitialCallback={true}
                        pageLinkClassName={"page-link"}
                        previousLinkClassName={"page-link"}
                        nextLinkClassName={"page-link"}
                        pageClassName={"page-item"}
                        previousClassName={"page-item"}
                        nextClassName={"page-item"}
                        disabledClassName={"disabled"}
                    />
                </div>
            </div>

            <Modal
                isOpen={isEditModalOpen}
                onRequestClose={closeEditModal}
                contentLabel="User Details"
                className="modal-content"
                overlayClassName="modal-overlay"
            >
                <UpdateFaqCategory faqcat={selectedEdit} closeModal={closeEditModal} onSuccess={run} />
            </Modal>
            <Modal
                isOpen={isDeleteModalOpen}
                onRequestClose={closeDeleteModal}
                contentLabel="Delete Confirmation"
                className="modal-content"
                overlayClassName="modal-overlay"
            >
                <DeleteButton data={selectedEdit} page="faqcat" closeModal={closeDeleteModal} onSuccess={run} />
            </Modal>
        </div>
    );
}

export default FaqcategoryList;
